import { Component, Input, OnInit } from '@angular/core';
import { mapHelper } from '@helpers';
import { MapConfigInterface } from '@models';
import { MapMarkerTimedInterface, MapMarkerTimeReferenceInterface } from '@mzima-client/sdk';
import L, {
  control,
  FitBoundsOptions,
  LatLngBounds,
  Map,
  MapOptions,
  marker,
  tileLayer,
} from 'leaflet';
import 'leaflet-extra-markers';
import { SessionService } from '../../../core/services/session.service';

@Component({
  selector: 'app-map-with-marker',
  templateUrl: './map-with-marker.component.html',
  styleUrls: ['./map-with-marker.component.scss'],
})
export class MapWithMarkerComponent implements OnInit {
  @Input() public marker: { lat: number; lon: number };
  @Input() public color = '23282f';
  // @Input() public type = 'default';
  @Input() public type: 'circle' | 'square' | 'star' | 'penta' = 'circle';
  @Input() public markerIcon: {
    prefix: string;
    name: string;
    iconColor: string;
  } = {
    prefix: 'fa',
    name: 'fa-circle',
    iconColor: 'white',
  };
  @Input() public markerTimedStyles?: MapMarkerTimedInterface[];
  @Input() public markerTimeReference?: MapMarkerTimeReferenceInterface;

  public mapReady = false;
  public mapConfig: MapConfigInterface;
  public leafletOptions: MapOptions;
  public mapFitToBounds: LatLngBounds;
  public fitBoundsOptions: FitBoundsOptions = {
    animate: true,
  };
  public mapLayers: any[] = [];

  constructor(private sessionService: SessionService) {}

  ngOnInit(): void {
    this.mapConfig = this.sessionService.getMapConfigurations();

    const currentLayer =
      mapHelper.getMapLayers().baselayers[this.mapConfig.default_view!.baselayer];

    this.leafletOptions = {
      scrollWheelZoom: true,
      zoomControl: false,
      layers: [tileLayer(currentLayer.url, currentLayer.layerOptions)],
      center: [this.marker.lat, this.marker.lon],
      zoom: this.mapConfig.default_view!.zoom,
    };

    const mapMarker = marker(
      {
        lat: this.marker.lat,
        lng: this.marker.lon,
      },
      {
        // icon: pointIcon(this.color, this.type ? this.type : 'default'),
        icon: L.ExtraMarkers.icon({
          prefix: this.markerIcon.prefix,
          icon: this.markerIcon.name,
          svg: true,
          shape: this.type,
          markerColor: `#${this.color}`,
          iconColor: `#${this.markerIcon.iconColor}`,
          className: this.markerTimedStyles
            ? mapHelper.injectMarkerStyles(this.markerTimedStyles, this.markerTimeReference)
            : '',
        }),
        opacity: this.markerTimedStyles
          ? mapHelper.getTimedOpacity(this.markerTimedStyles, this.markerTimeReference)
          : 1,
      },
    );
    this.mapLayers.push(mapMarker);

    this.mapReady = true;
  }

  public onMapReady(map: Map) {
    control.zoom({ position: 'bottomleft' }).addTo(map);
  }
}
